import { render, staticRenderFns } from "./ViewMagazinePost.vue?vue&type=template&id=72514552"
import script from "./ViewMagazinePost.vue?vue&type=script&lang=js"
export * from "./ViewMagazinePost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports